module.exports = __webpack_public_path__ + "img/FTM.6d7c6dd1.svg";